import { ProjectUserGeneratedEntity } from "./generated/ProjectUserGeneratedEntity";

export abstract class ProjectUserEntity extends ProjectUserGeneratedEntity {
    // Comment to preserve new line
}
